export const ESG_RATINGS_SCALE_IMAGE = `
<svg width="300px" height="236px" viewBox="0 0 300 236" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<title>Group</title>
<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	<g id="Analysis_7-portfolios_GovernancePillar" transform="translate(-1017.000000, -897.000000)">
		<g id="Group-5" transform="translate(1017.000000, 836.000000)">
			<g id="Group" transform="translate(0.000000, 61.000000)">
				<text id="AAA-AA-A-BBB-BB-B-CC" font-family="FortBook" font-size="14" font-weight="300" line-spacing="20" fill="#000000">
					<tspan x="178" y="14">AAA</tspan>
					<tspan x="178" y="50">AA</tspan>
					<tspan x="178" y="86">A</tspan>
					<tspan x="178" y="122">BBB</tspan>
					<tspan x="178" y="158">BB</tspan>
					<tspan x="178" y="194">B</tspan>
					<tspan x="178" y="230">CCC</tspan>
				</text>
				<text id="Leader-Average-Lagga" font-family="FortBook" font-size="14" font-weight="300" line-spacing="20" fill="#000000">
					<tspan x="242" y="14"></tspan>
					<tspan x="242" y="50">Leader</tspan>
					<tspan x="242" y="86"></tspan>
					<tspan x="242" y="122">Average</tspan>
					<tspan x="242" y="158"></tspan>
					<tspan x="242" y="194">Laggard</tspan>
				</text>
				<text id="8.6-–-10-7.1-–-8.6-5" font-family="FortBook" font-size="14" font-weight="300" line-spacing="20" fill="#000000">
					<tspan x="0" y="14">8.6 – 10</tspan>
					<tspan x="0" y="50">7.1 – 8.6</tspan>
					<tspan x="0" y="86">5.7- 7.1</tspan>
					<tspan x="0" y="122">4.3 – 5.7</tspan>
					<tspan x="0" y="158">2.9 – 4.3</tspan>
					<tspan x="0" y="194">1.4. – 2.9</tspan>
					<tspan x="0" y="230">0 – 1.4 </tspan>
				</text>
				<rect id="Rectangle-15" fill="#01573C" x="76" y="2.05689534" width="86" height="15.9962538"></rect>
				<rect id="Rectangle-15" fill="#00AE73" x="76" y="38.0568953" width="86" height="15.9962538"></rect>
				<rect id="Rectangle-15" fill="#BFF5DD" x="76" y="74.0568953" width="86" height="15.9962538"></rect>
				<rect id="Rectangle-15-Copy" fill="#F2A800" x="76" y="110.056895" width="86" height="15.9962538"></rect>
				<rect id="Rectangle-15-Copy-2" fill="#FFCE00" x="76" y="146.056895" width="86" height="15.9962538"></rect>
				<rect id="Rectangle-15-Copy-3" fill="#FFF790" x="76" y="182.056895" width="86" height="15.9962538"></rect>
				<rect id="Rectangle-15" fill="#CC0018" x="76" y="218.056895" width="86" height="15.9962538"></rect>
				<line x1="225.5" y1="10.5" x2="225.5" y2="100.5" id="Line-4" stroke="#979797" stroke-linecap="square" fill-rule="nonzero"></line>
				<line x1="225.5" y1="145" x2="225.5" y2="231.5" id="Line-4-Copy" stroke="#979797" stroke-linecap="square" fill-rule="nonzero"></line>
			</g>
		</g>
	</g>
</g>
</svg>
`;
